const ROLE_LABELS = {
  PLATFORM_SUPER_ADMIN: 'PREIKA緊急最高管理者',
  PLATFORM_OPERATIONS_ADMIN: 'PREIKA運営管理者',
  PLATFORM_SUPPORT_VIEWER: 'PREIKAサポート閲覧者',
  TENANT_OWNER: '契約企業管理者（自社最上位）',
  TENANT_SYSTEM_ADMIN: '社内システム管理者',
  EXECUTIVE_ADMIN: '経営管理者',
  CLERK: '事務担当者',
  EMPLOYEE: '一般社員'
}

/*
 * 標準の権限グループの説明文は、名前（ROLE_LABELS）と同じく画面の側で持つ（2026-09-26）。
 *
 * DB の m_role.description には、作った当時の「従来admin相当」「社内SE向けロール」
 * 「役割」などの言葉が残っている。新規登録・更新の画面でチェック欄の下にそのまま
 * 出ていて、利用者には意味が伝わらなかった（呼び名は「権限グループ」へ改めた）。
 * 会社が自分で作った権限グループ（ここに無い role_code）は、会社の書いた説明のまま。
 *
 * **説明は「標準の用途」で、今できることの約束ではない**（監査 2026-09-26）。
 * 会社は標準を自社用に変えて中身を減らせる（role_code は同じまま）。複数の権限グループを
 * 付けた人は合わせた内容になり、ご契約で使えない機能もある。なので「〜を行えます」と
 * 言い切らず、用途の言い方にし、選ぶ欄の上に ROLE_DESCRIPTION_NOTE を1回出す。
 * 自社用に変えた写しには CUSTOMIZED_ROLE_NOTE を前に付ける。写しの見分けは system_role_flg = false
 * （/users/roles の standard_role_flg は「標準から写したもの」も true なので使えない）。
 * 言葉は、実際の標準の中身と監査の指摘を添えて Gemini に決めてもらった。
 */
const ROLE_DESCRIPTIONS = {
  TENANT_OWNER: '自社内の契約内容や管理者の設定など、組織全体の最高管理業務を担当します。',
  EXECUTIVE_ADMIN: '全社的な申請承認や売上・請求の確認、経営分析などを担う標準の管理者向けです。',
  CLERK: '自身の各種申請に加え、月次集計の確認や社員情報の設定などを担う事務担当者向けです。',
  EMPLOYEE: '自身の勤怠・申請・精算処理や、割り当てられた承認・登録業務を担当する標準設定です。',
  TENANT_SYSTEM_ADMIN: '社員・部署・権限の管理や自社設定など、システム運用の維持を担当します。'
}

export const CUSTOMIZED_ROLE_NOTE = '自社用に設定変更されています。'

export const ROLE_DESCRIPTION_NOTE =
  '表示中の内容は標準の用途です。実際の権限は自社の設定変更や複数選択、ご契約内容により異なり、「権限管理」画面で確認できます。'

export function standardRoleDescription (code) {
  return ROLE_DESCRIPTIONS[code] || ''
}

/** 標準の説明がある role_code で、自社用に変えた写しなら添え書きを付ける。 */
function roleDescription (code, systemRoleFlg, stored) {
  const standard = standardRoleDescription(code)
  if (!standard) return stored || ''
  return systemRoleFlg === false ? CUSTOMIZED_ROLE_NOTE + standard : standard
}

function value (item, ...keys) {
  for (const key of keys) {
    if (item && Object.prototype.hasOwnProperty.call(item, key)) return item[key]
    const upper = key.toUpperCase()
    if (item && Object.prototype.hasOwnProperty.call(item, upper)) return item[upper]
  }
  return null
}

export function normalizeRoles (items) {
  if (!Array.isArray(items)) return []
  return items.map(item => {
    const code = value(item, 'roleCode', 'role_code')
    const name = value(item, 'roleName', 'role_name')
    return {
      id: value(item, 'id'),
      code,
      name: ROLE_LABELS[code] || name || '名称未設定の権限グループ',
      description: roleDescription(code, value(item, 'systemRoleFlg', 'system_role_flg'), value(item, 'description')),
      displayOrder: Number(value(item, 'displayOrder', 'display_order') || 9999)
    }
  }).filter(role => role.id != null)
    .sort((left, right) => left.displayOrder - right.displayOrder)
}

export function defaultRoleIds (roles) {
  const employee = roles.find(role => role.code === 'EMPLOYEE')
  return employee ? [employee.id] : []
}

export function roleNames (roles, selectedIds) {
  const selected = new Set((selectedIds || []).map(value => String(value)))
  return roles.filter(role => selected.has(String(role.id))).map(role => role.name)
}

export function toggleRoleId (selectedIds, roleId, checked) {
  const next = Array.isArray(selectedIds) ? selectedIds.slice() : []
  const index = next.findIndex(value => String(value) === String(roleId))
  if (checked && index < 0) next.push(roleId)
  if (!checked && index >= 0) next.splice(index, 1)
  return next
}
